import { DynamicScript } from 'globals/DynamicScript';

const RECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js?&render=explicit';

export default {
    methods: {
        recaptchaFormSubmit(form, callback = null) {
            if (this.fieldRecaptcha) {
                this.$emit('triggerRecaptcha');
                this.triggered = new Date();
            } else {
                if (callback) {
                    callback();
                } else {
                    form.submit();
                }
            }
        },
    },
    data() {
        return {
            triggered: null,
        };
    },
    mounted() {
        if (this.fieldRecaptcha && !window.grecaptcha) {
            new DynamicScript(RECAPTCHA_SRC, { id: 'recaptcha-js' });
        }
    },
};
